export class AppConstant {
  public static ROUTE_PATH_LOGIN = '/login'

  public static ROUTER_LOGIN_TITLE = 'Login'
  public static ROUTE_PATH_API_LOGIN = '/auth/login'
  public static KEY_ACCESS_TOKEN = 'ACCESS_TOKEN'
  public static REFRESH_TOKEN = 'REFRESH_TOKEN'
  public static KEY_USERNAME = 'username'
  public static KEY_USERID = 'userid'
  public static KEY_COMPANY_ID = 'companyid'
  public static KEY_COMPANY_CODE = 'companycode'
  public static KEY_COMPANY_NAME = 'companyname'

  public static URL_API_LOCAL = 'https://service.invoicex.vn/'
  public static BASE_URL = 'http://117.4.194.207:8081/'
  public static LANDING_PAGE_URL = 'https://invoicex.vn/'

  public static PARTNER_PRIORITY_NORMAL = 1;
  public static PARTNER_PRIORITY_NECESSARY = 2;
  public static PARTNER_PRIORITY_INTERESTED = 3;
  public static PARTNER_PRIORITY_SIGNIFICANT = 4;
  public static PARTNER_PRIORITY_VIP = 5;

  public static PARTNER_STATUS_NON_CONNECT = 0;
  public static PARTNER_STATUS_INVITE = 1;
  public static PARTNER_STATUS_REFUSE = 2;
  public static PARTNER_STATUS_CONNECTED = 3;

  public static PARTNER_VALIDATE_PHONE_LENGTH = 10;

  public static TIME_EXPIRED_TOKEN_CONNECTION = 7 * 24 * 60 * 60;
  public static MIN_LENGTH_PASSWORD = 8;
  public static MAX_LENGTH_PASSWORD = 32;
  public static MAX_LENGTH_TEXT = 255;
  public static MAX_LENGTH_SKU_CODE = 20;
  public static MAX_LENGTH_SHOP_CODE_GHTK = 10;

  public static DELIVERY_STATUS_SENT = 1;
  public static DELIVERY_STATUS_IN_PROCESS = 2;
  public static DELIVERY_STATUS_APPROVED = 3;
  public static DELIVERY_STATUS_REJECT = 4;

  public static DROPDOWN_ACTION_COMMON = 1;
  public static DROPDOWN_ACTION_FORMAT_FILE = 2;
  public static DROPDOWN_ACTION_PRODUCT = 3;
  public static DROPDOWN_ACTION_PAGE = 4;
  public static DROPDOWN_ACTION_PARTNER = 5;
  public static DROPDOWN_ACTION_INVITE_CONNECT = 6;
  public static DROPDOWN_ACTION_ARRIVAL = 7;
  public static DROPDOWN_SYNC_KIOTVIET = 8;
  public static DROPDOWN_ACTION_STORE = 9;
  public static DROPDOWN_ACTION_SYNC_GHTK = 10;
  public static DROPDOWN_ACTION_ORDER_GHTK = 11;
  public static ACTION_TYPE_DELETE = 1;
  public static ACTION_TYPE_EXPORT_EXCEL = 2;
  public static ACTION_TYPE_EXPORT_CSV = 3;
  public static ACTION_TYPE_EXPORT_PDF = 4;
  public static ACTION_TYPE_SYNC_KIOTVIET = 5;
  public static ACTION_ENABLE_FORMAT_FILE = 1;
  public static ACTION_DOWNLOAD_FORMAT_FILE = 2;
  public static ACTION_TYPE_ACCEPT = 5;
  public static ACTION_ARRIVAL_CHANGE_STATUS = 1;
  public static ACTION_ARRIVAL_CANCEL = 2;
  public static ACTION_STORE_DELETE = 1;
  public static ACTION_EN_DISABLE_GHTK = 2;
  public static ACTION_PRINT_LABELS_ORDER_GHTK = 1;
  public static ACTION_CANCEL_ORDER_GHTK = 2;

  public static LIMIT_PAGE_10 = 10;
  public static LIMIT_PAGE_20 = 20;
  public static LIMIT_PAGE_50 = 50;

  public static PAGE_DEFAULT = 1;

  public static TAB_OWNER = 1;
  public static TAB_PARTNER = 2;

  public static TYPE_FILE_EXCEL = 1;
  public static TYPE_FILE_CSV = 2;
  public static TYPE_FILE_PDF = 3;

  public static STATUS_FORMAT_FILE_DISABLE = 1;
  public static STATUS_FORMAT_FILE_PUBLISH = 2;

  public static STATUS_ARRIVAL_CREATE = 1;
  public static STATUS_ARRIVAL_START_MOVE = 2;
  public static STATUS_ARRIVAL_FINISH_MOVE = 3;
  public static STATUS_ARRIVAL_CANCEL = 4;
  public static TAB_PRODUCT_KIOTVIET = 1;
  public static TAB_INVOICE_KIOTVIET = 2;
  public static TAB_PARTNER_KIOTVIET = 3;
  public static TAB_DELIVERY_KIOTVIET = 4;

  public static EXPORT_BILL_FALSE = 0;
  public static EXPORT_BILL_TRUE = 1;
  public static GHTK_EXPIRATION_DATE_TOKEN_OPTION_8 = 8;
  public static GHTK_EXPIRATION_DATE_TOKEN = [
    {
      value: 1,
      name: 'Không bao giờ'
    },
    {
      value: 2,
      name: '30 phút'
    },
    {
      value: 3,
      name: '1 giờ'
    },
    {
      value: 4,
      name: '1 ngày'
    },
    {
      value: 5,
      name: '7 ngày'
    },
    {
      value: 6,
      name: '30 ngày'
    },
    {
      value: 7,
      name: '1 năm'
    },
    {
      value: 8,
      name: 'Tuỳ chọn'
    }
  ]
  public static GHTK_ORDER_TAGS = [
    {
      value: 2,
      name: 'Giá trị cao/Đặc biệt',
      detail: 'Những mặt hàng có giá trị hàng hoá > 3,000,000đ (với shop B2C) và > 1,000,000đ (với shop C2C). Các hàng hoá giá trị cao sẽ tính thêm phí khai giá là khoản khai giá cho các rủi ro trong quá trình vận chuyển hoặc lưu kho. Phí khai giá bằng 0.5% giá trị hàng hoá. GHTK sẽ bồi hoàn 100% giá trị khai giá khi mất hàng (tối đa 20,000,000 VNĐ) nếu có giấy tờ chứng minh nguồn gốc và giá trị hàng hoá (hoá đơn nhập hàng, hoá đơn mua hàng hợp lệ và khớp với thông tin sản phẩm trên hệ thống GHTK,...). Trong trường hợp shop không thể chứng minh nguồn gốc và giá trị hàng hoá, bồi thường tối đa 04 lần cước phí vận chuyển.'
    },
    {
      value: 10,
      name: 'Cho xem hàng',
      detail: 'Khách hàng được xem sản phẩm trước khi nhận hàng'
    },
    {
      value: 13,
      name: 'Gọi shop khi khách không nhận hàng',
      detail: 'Nhân viên GHTK sẽ liên hệ với shop nếu gặp vấn đề như: sai thông tin người nhận, không liên lạc được, KH từ chối nhận hàng'
    },
    {
      value: 17,
      name: 'Giao hàng 1 phần chọn sản phẩm',
      detail: 'Hỗ trợ khách chỉ nhận và trả tiền 1 phần hàng. Phần còn lại sẽ được trả về shop với mức phí nội tỉnh = 5.000đ/đơn, liên tỉnh = 50% phí ship'
    },
    {
      value: 18,
      name: 'Giao hàng 1 phần đổi trả hàng',
      detail: 'Hỗ trợ giao 1 sản phẩm đến cho KH và mang phần hàng còn lại trả về shop. Phí ship của đơn hàng sẽ do shop và KH thỏa thuận (mặc định bằng phí ship). Phần hàng mang về cho shop được xem như đơn hàng trả với mức phí nội tỉnh = 5.000đ/đơn, liên tỉnh = 50% phí ship.'
    },
    {
      value: 19,
      name: 'Không giao được thu phí',
      detail: 'Hỗ trợ KH không nhận sản phẩm nhưng thu một phần phí cho shop. Phí cần thu mặc định bằng phí ship, shop có thể sửa giá trị tiền cần thu theo mong muốn của mình. Phần hàng mang về cho shop được xem như đơn hàng trả với mức phí nội tỉnh = 5.000đ/đơn, liên tỉnh = 50% phí ship, Lưu ý: Đối tác cần truyền thêm trường not_delivered_fee với giá trị 0 < not_delivered_fee <= 20,000,000đ'
    },
    {
      value: 62,
      name: 'Giao hàng 1 phần thu hồi chứng từ',
      detail: 'Hỗ trợ giao sản phẩm đến cho khách hàng và mang chứng từ (hóa đơn, giấy tờ) kèm theo phần hàng còn lại về cho shop.'
    }
  ]
  public static GHTK_STATUS_ORDER = [
    {
      status: 1,
      label: 'Chờ nhận giao hàng'
    },
    {
      status: 2,
      label: 'Nhận giao hàng'
    },
    {
      status: 3,
      label: 'Đã lấy hàng'
    },
    {
      status: 4,
      label: 'Đang giao hàng'
    },
    {
      status: 5,
      label: 'Đã giao hàng/Chưa đối soát'
    },
    {
      status: 6,
      label: 'Đã đối soát'
    },
    {
      status: 7,
      label: 'Không lấy được hàng'
    },
    {
      status: 8,
      label: 'Hoãn lấy hàng'
    },
    {
      status: 9,
      label: 'Không giao được hàng'
    },
    {
      status: 10,
      label: 'Delay giao hàng'
    },
    {
      status: 11,
      label: 'Đã đối soát công nợ trả hàng'
    },
    {
      status: 12,
      label: 'Đã điều phối lấy hàng/Đang lấy hàng'
    },
    {
      status: 13,
      label: 'Đơn hàng bồi hoàn'
    },
    {
      status: 20,
      label: 'Đang trả hàng (COD cầm hàng đi trả)'
    },
    {
      status: 21,
      label: 'Đã trả hàng (COD đã trả xong hàng)'
    },
    {
      status: 123,
      label: 'Shipper báo đã lấy hàng'
    },
    {
      status: 127,
      label: 'Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng'
    },
    {
      status: 128,
      label: 'Shipper báo delay lấy hàng'
    },
    {
      status: 45,
      label: 'Shipper báo đã giao hàng'
    },
    {
      status: 49,
      label: 'Shipper báo không giao được giao hàng'
    },
    {
      status: 49,
      label: 'Shipper báo delay giao hàng'
    },
  ]
  public static STATUS_SYNC_GHTK_INACTIVE = 0;
  public static STATUS_SYNC_GHTK_ACTIVE = 1;

  public static TYPE_MESSAGE_ZALO_INTRO_APP = 1;
  public static TYPE_MESSAGE_ZALO_INVITE_PARTNER = 2;
  public static TYPE_MESSAGE_ZALO_SEND_DELIVERY = 3;
  public static TYPE_MESSAGE_ZALO_CONFIRMED_DELIVERY = 4;
}

export const CommonText = {
  TOTAL_RECORD: (record : number, total: number) =>
      total > 0 ? `Hiển thị ${record}/${total} kết quả` : 'Hiển thị 0 kết quả tìm thấy'
}

export const AlertText = {
  ALERT_NOT_ALLOWED_USE_DELIVERY: 'Vui lòng chờ cho đến khi phía đối tác bắt đầu quá trình duyệt phiếu dữ liệu giao hàng.'
}
